export default "__VITE_ASSET__DGzs95rM__"